export enum ContractPeriodType {
    FIXED = 'fixed',
    CONTINUOUS = 'continuous',
}

export enum ContractPeriodStart {
    CURRENT = 'current',
    NEXT = 'next',
}

export enum InterestRateCalculationMethod {
    IR_ACT_360 = 'IR_ACT_360',
    IR_ACT_365 = 'IR_ACT_365',
    IR_30_360 = 'IR_30_360',
}

export enum CalculationStartDate {
    ACCEPTANCE_DATE = 'acceptance_date',
    PAID_DATE = 'paid_date',
}

export enum PayoutTaskFinishedType {
    SUCCESS = 'success',
    WARNING = 'warning',
    HAS_ERRORS = 'has-errors',
    ERROR = 'error',
    ERROR_WHILE_GENERATING = 'error_while_generating',
}

export enum ContractType {
    CASH = 'cash',
    VOUCHER = 'voucher',
    STOCK_EMISSION = 'stock_emission',
}

export enum ContractEndCause {
    EXIT = 'EXIT',
    INSOLVENCY = 'INSOLVENCY',
    OTHER = 'OTHER',
}

export enum KistaServiceType {
    BOP = 'BOP', // BOP = csv for uploading via online portal
    ELMA = 'ELMA', // ELMA = csv for uploading via sftp server
}

export enum ConversionTriggerType {
    IPO = 'ipo',
    ANNUAL = 'annual',
    PRICE_THRESHOLD = 'price_threshold',
    MATURITY = 'maturity',
}

export enum ConversionPriceFormula {
    VWAP = 'vwap',
    FIXED = 'fixed',
    IPO_PRICE = 'ipo_price',
}

export enum RepaymentType {
    BULLET = 'bullet',
    REGULAR = 'regular',
    IRREGULAR = 'irregular',
}
